// extracted by mini-css-extract-plugin
export default {"logoImg":"logo_logoImg__Rp-D0","pop":"logo_pop__0mJ6I"};